import { Card } from "@/components/Kpi";
import { eurShort, num } from "@/lib/format";

/** Barre di avanzamento per commerciale: valore progressivo sul budget assegnato. */
export function BarreAvanzamento({ titolo, sottotitolo, righe, colore, testId }) {
  return (
    <Card className="p-4 sm:p-6" data-testid={testId}>
      <div className="uppercase text-xs tracking-[0.18em] font-semibold text-slate-500">{titolo}</div>
      {sottotitolo && <div className="text-xs text-slate-400 mt-1">{sottotitolo}</div>}
      <div className="mt-5 space-y-4">
        {righe.map((r) => {
          const perc = r.budget ? (r.valore || 0) / r.budget * 100 : null;
          return (
            <div key={r.label} data-testid={`${testId}-${r.slug}`}>
              <div className="flex items-baseline gap-1.5 text-xs whitespace-nowrap">
                <span className="font-medium truncate min-w-0 flex-1">{r.label}</span>
                <span className="ml-auto font-mono text-slate-500 shrink-0">{eurShort(r.valore)}</span>
                <span className="font-mono text-[11px] text-slate-400 shrink-0">/ {eurShort(r.budget)}</span>
                <span className={`font-mono text-[11px] font-semibold w-12 text-right shrink-0
                  ${perc === null ? "text-slate-400"
                    : perc >= 100 ? "text-emerald-600" : "text-slate-700"}`}>
                  {perc === null ? "—" : `${num(perc, 1)}%`}
                </span>
              </div>
              <div className="mt-1.5 h-3 w-full rounded-full bg-slate-100 overflow-hidden">
                <div className="h-full rounded-full transition-all duration-700"
                  style={{ width: `${Math.min(100, perc || 0)}%`, background: colore }} />
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-4 text-[11px] text-slate-400">
        La barra piena corrisponde al budget assegnato (100%).
      </div>
    </Card>
  );
}
